import styled from "styled-components";
import {wheelGoldBorder} from "../../wheel-color-helper";
import {rotatingWheelSizeInPercentage} from "../../wheel-sizing-helper";

export const WheelOuterBorderDefaultBox = styled.div`
    position: absolute;
    width: calc(${rotatingWheelSizeInPercentage}% + 4px);
    height: calc(${rotatingWheelSizeInPercentage}% + 4px);
    border-radius: 50%;
    background-color: ${wheelGoldBorder};
`